(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.sanitizeString = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = sanitizeString;

  function sanitizeString(value) {
    if (typeof value !== 'string') {
      return value;
    } // If value is a date, then return


    if (!Number.isNaN(new Date(value).getDate())) {
      return value;
    } // Allow alpha-numeric characters, comma, blank space,
    // Full Width alpha-numeric characters, Hiragana-Katakana [ぁ-んァ-ン], Kanji [一-龥]
    // Remove any other character
    // eslint-disable-next-line no-irregular-whitespace


    var sanitizedText = value.replace(/[^一-龯ぁ-んァ-ンぁ-んァ-ンＡ-ｚＡ-ｚＡ-ｚa-zA-Z0-9 ,ー]/g, '');
    return sanitizedText;
  }
});